export default __webpack_public_path__ + "static/media/map_pin_light.30abb7e5.svg";